import { render, staticRenderFns } from "./h5-config-manage.vue?vue&type=template&id=6dfefdc5&scoped=true"
import script from "./h5-config-manage.vue?vue&type=script&lang=js"
export * from "./h5-config-manage.vue?vue&type=script&lang=js"
import style0 from "./h5-config-manage.vue?vue&type=style&index=0&id=6dfefdc5&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dfefdc5",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6dfefdc5')) {
      api.createRecord('6dfefdc5', component.options)
    } else {
      api.reload('6dfefdc5', component.options)
    }
    module.hot.accept("./h5-config-manage.vue?vue&type=template&id=6dfefdc5&scoped=true", function () {
      api.rerender('6dfefdc5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pageconfig/components/h5-config-manage.vue"
export default component.exports